import { render, staticRenderFns } from "./CompanyTariffAddEditView.vue?vue&type=template&id=6d764acc&scoped=true&"
import script from "./CompanyTariffAddEditView.vue?vue&type=script&lang=js&"
export * from "./CompanyTariffAddEditView.vue?vue&type=script&lang=js&"
import style0 from "./CompanyTariffAddEditView.vue?vue&type=style&index=0&id=6d764acc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d764acc",
  null
  
)

export default component.exports